import React from "react";
import { Card, Image, Button, Divider } from "semantic-ui-react";

import { Roles } from "../../interfaces";
import { GetUser } from "../../services/auth";
import ImageZoom from "../../components/ImageZoom";

export interface ICardSocial {
    nome: string;
    descricao: string;
    path: string;
    roles: Roles[];
}

const CardSocial: React.FC<ICardSocial> = ({ nome, descricao, path, roles }: ICardSocial) => {
    const { role } = GetUser();
    if (roles.find(x => x === role)) {
        return (
            <Card>
                <Card.Content>
                    <Card.Header>{nome}</Card.Header>
                    <Card.Description>
                        {descricao}
                    </Card.Description>
                </Card.Content>
                <Card.Content>
                    <Image
                        fluid
                        label={<ImageZoom imagePath={path} />}
                        src={path}
                    />
                </Card.Content>
            </Card>
        );
    } else {
        return null;
    }
};

export default CardSocial;
